<template>
  <div class="eSiteIndex"  @click="dblBtn">
    <div class="configBtn" v-show="showBtn == true" @click.stop>
      <el-button type="info" @click="toConfig">修改配置</el-button>
    </div>
    <div class="init_view" v-if="init">
      <div class="companyName">
        <h1 class="title">{{companyName}}</h1>
      </div>
      <div class="operation">
        <div class="default_block" @click.stop="toLogin('en-forward')"><span>正向物流入库</span></div>
        <div class="default_block" @click.stop="toLogin('ex-forward')"><span>正向物流出库</span></div>
        <div class="default_block" @click.stop="toLogin('en-reverse')"><span>反向物流入库</span></div>
        <div class="default_block" @click.stop="toLogin('ex-reverse')"><span>反向物流出库</span></div>
      </div>
    </div>
    <div class="login_view" v-if="!init">
      <h1 class="title">请输入你的账号密码</h1>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="1.5rem">
        <el-form-item label="账号" prop="account">
          <el-input type="text" autocomplete="off" v-model="ruleForm.account" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" autocomplete="off"  v-model="ruleForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click.stop="submitForm('ruleForm')">登录</el-button>
          <el-button @click.stop="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="default_btn" v-if="!init" @click.stop="toReturn">返回</div>
  </div>
</template>

<script>
var _this
// import '../../../static/css/common.less'
export default {
  name:'',
  data() {
    var validateAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else {
        // if (this.ruleForm.checkPass !== '') {
        //   this.$refs.ruleForm.validateField('checkPass');
        // }
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    return {
      init: true,
      showBtn: false,
      num: 0,//点击次数
      companyName: '极酷物联',
      actionType: '',
      ruleForm: {
          account: '',
          password: '',
        },
      rules: {
        account: [
          { validator: validateAccount, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
      },
    };
  },
  created() {

  },
  mounted() {
    _this = this;
    console.info(_this)
  },
  methods: {
    // 跳转到配置页
    toConfig() {
      this.$router.push({
        path:'/CConfigSetting',
        query:{
          'project':true,
        }
      })
    },

    // 连续点击屏幕5次
    dblBtn() {
      var _this = this;
      this.num++
      if(this.num==1) {
        _this.timer1=new Date().getTime()/1000
      }
      if(this.num==5) {
        this.timer4= new Date().getTime()/1000
        if(_this.timer4-_this.timer1<=2) {
          _this.num=0
          _this.showBtn=true
          setTimeout(function() {
            _this.showBtn = false
          },5000);
        } else {
          this.num=0
        }
      }
    },

    // 初始面板点击选择出入库，进入登录面板
    toLogin(e) {
      _this.init = false;
      _this.actionType = e;
      console.log('登录界面时的操作类型：',_this.actionType);
    },

    toReturn() {
      _this.init = true;
      _this.ruleForm.account = '';
      _this.ruleForm.password = '';
    },

    // 登录面板-登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.actionType);
          // TODO: 向后台验证身份，验证通过后执行以下代码
          switch (this.actionType) {
            // 入库
            case 'en-forward': // 正向
              this.$router.push({
                path: '/eSite/enWarehouse',
                query: {actionType: this.actionType}
              })
              break;
            case 'en-reverse': // 反向
              this.$router.push({
                path: '/eSite/enWarehouse',
                query: {actionType: this.actionType}
              })
              break;
            // 出库
            case 'ex-forward': // 正向
              this.$router.push({
                path: '/eSite/exWarehouse',
                query: {actionType: this.actionType}
              })
              break;
            case 'ex-reverse': // 反向
              this.$router.push({
                path: '/eSite/exWarehouse',
                query: {actionType: this.actionType}
              })
              break;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    
    // 登录面板-重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>

<style lang="less">
.eSiteIndex {
  height: 100vh;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .configBtn {
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .init_view {
    width: 60%;
    .companyName {
      // text-align: center;
      margin-bottom: 1.5rem;
      h1 {
        font-size: 1rem;
        letter-spacing: 0.1rem;
      }
    }
    .operation {
      width: 100%;
      display: flex;
      justify-content: space-around;
      div {
        width: 2rem;
        height: 2rem;
        font-size: 0.4rem;
        border-radius: 2rem;
        span {
          display: block;
          padding: 0.1rem;
          text-align: center;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .login_view {
    width: 50%;
    position: absolute;
    z-index: 100;
    .title {
      font-size: 0.8rem;
      margin-bottom: 0.4rem;
    }
    .el-form-item {
      margin-bottom: 0.6rem;
    }
    .el-form-item__label {
      color: #fff;
      height: 0.8rem;
      font-size: 0.4rem;
      line-height: 0.8rem;
      text-align: center;
      padding: 0;
      border-radius: 0.04rem 0 0 0.04rem;
      background: linear-gradient(0deg,#0669be,#4cacff);
      box-shadow: 0 0 0.2rem #2c4b64;
    }
    .el-form-item__content {
      .el-button {
        font-size: 0.35rem;
      }
      .el-button+.el-button {
        margin-left: 0.4rem;
      }
    }
    .el-input {
      font-size: 0.35rem;
      .el-input__icon {
        width: 0.46rem;
      }
    }
    .el-form-item__error {
      font-size: 0.26rem;
    }
    .el-input__inner {
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.3rem;
      vertical-align: 0.04rem;
      border-radius: 0 0.04rem 0.04rem 0;
    }
  }
  .default_btn {
    position: absolute;
    right: 1.15rem;
    bottom: 1.15rem;
    width: 2.0rem;
    height: 0.7rem;
    font-size: 0.35rem;
    line-height: 0.7rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/CEsite/eSiteIndex.vue